(function () {
  'use strict';

  function bcFormatMoney(cents) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (_) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }

  function bcRenderPrice(card) {
    var product = card.closest('[data-product-handle]');
    if (!product || !product.hasAttribute('data-bcj-card-price')) return;
    var selection = card._bcjPriceSelection;
    var price = selection ? selection.price : Number(product.getAttribute('data-bcj-card-price'));
    var compareAt = selection ? selection.compareAt : Number(product.getAttribute('data-bcj-card-compare'));
    var variantId = selection ? selection.variantId : product.getAttribute('data-bcj-card-variant');
    var from = !selection && product.getAttribute('data-bcj-card-varies') === 'true';
    var promotion = window.BCJPromotion && window.BCJPromotion.details({
      handle: product.getAttribute('data-product-handle'), variantId: variantId, price: price
    });
    var promotional = promotion && promotion.active && promotion.price < price;
    if (promotional) {
      compareAt = price;
      price = promotion.price;
    }
    var isOnSale = compareAt > 0 && compareAt > price;
    var savePct = isOnSale ? Math.round((compareAt - price) / compareAt * 100) : 0;

    card.querySelectorAll('.grid-product__price').forEach(function (box) {
      if (box._bcjOriginalHTML === undefined) box._bcjOriginalHTML = box.innerHTML;
      // Retain the server's native price, translations and unit price when no offer applies.
      if (!selection && !promotional) {
        if (box._bcjPromotionRendered) box.innerHTML = box._bcjOriginalHTML;
        box._bcjPromotionRendered = false;
        return;
      }
      var html = '';
      if (from) html += 'From ';
      if (isOnSale) {
        html += '<span class="visually-hidden">Regular price</span>';
        html += '<span class="grid-product__price--original">' + bcFormatMoney(compareAt) + '</span>';
        html += '<span class="visually-hidden">Sale price</span>';
      }
      html += bcFormatMoney(price);
      if (promotional) {
        html += '<span class="grid-product__price--savings" style="display:block;white-space:normal;font-size:11px;line-height:1.3;margin-top:5px">Beefcake Days · ' + promotion.percent + '% off one-time</span>';
      } else if (isOnSale) {
        html += '<span class="grid-product__price--savings">Save ' + savePct + '%</span>';
      }
      if (box.innerHTML !== html) box.innerHTML = html;
      box._bcjPromotionRendered = Boolean(promotional);
    });
  }

  function bcUpdatePrice(quickAdd, price, compareAt, variantId) {
    var card = quickAdd.closest('.grid-product__content');
    if (!card) return;
    card._bcjPriceSelection = { price: price, compareAt: compareAt, variantId: variantId };
    bcRenderPrice(card);
  }

  function bcRefreshPrices() {
    document.querySelectorAll('.grid-product__content').forEach(bcRenderPrice);
  }

  function initCards() {
    bcRefreshPrices();
    // --- Image overlay when size picker opens ---
    document.querySelectorAll('.grid-product__content').forEach(function (card) {
      if (card._bcOverlayInit) return;
      card._bcOverlayInit = true;

      var imageMask = card.querySelector('.grid-product__image-mask');
      var chooseSizeBtn = card.querySelector('.choose-size-btn');
      if (!imageMask || !chooseSizeBtn) return;

      chooseSizeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        imageMask.classList.toggle('size-is-open-image-overlay');
      });

      card.querySelectorAll('.size-option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          imageMask.classList.remove('size-is-open-image-overlay');
        });
      });
    });

    // Close image overlay on outside click (attach once)
    if (!document._bcOverlayDocHandler) {
      document._bcOverlayDocHandler = true;
      document.addEventListener('click', function (e) {
        document.querySelectorAll('.grid-product__content').forEach(function (card) {
          if (!card.contains(e.target)) {
            var mask = card.querySelector('.grid-product__image-mask');
            if (mask) mask.classList.remove('size-is-open-image-overlay');
          }
        });
      });
    }

    // --- Size selector / quick-add ---
    document.querySelectorAll('.card__quick-add').forEach(function (quickAdd) {
      if (quickAdd._bcQuickAddInit) return;
      quickAdd._bcQuickAddInit = true;

      var chooseSizeBtn = quickAdd.querySelector('.choose-size-btn');
      var sizeOptions = quickAdd.querySelector('.size-options');
      var selectedVariantInput = quickAdd.querySelector('.selected-variant-id');
      var sizeSelector = quickAdd.querySelector('.size-selector');
      var addToCartBtn = quickAdd.querySelector('.add-to-cart-btn');
      var addToCartBtnMobile = quickAdd.querySelector('.add-to-cart-btn-mobile');

      // Single-variant cards have no size picker — skip
      if (!chooseSizeBtn || !sizeOptions || !selectedVariantInput) return;

      var isOpen = false;

      // Toggle the size picker
      chooseSizeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        isOpen = !isOpen;
        sizeOptions.classList.toggle('hidden', !isOpen);
        chooseSizeBtn.classList.toggle('size-options--open', isOpen);
        if (sizeSelector) sizeSelector.classList.toggle('size-is-open', isOpen);
      });

      // Select a size option
      sizeOptions.addEventListener('click', function (e) {
        e.stopPropagation();
        var sizeBtn = e.target.closest('.size-option');
        if (!sizeBtn || sizeBtn.disabled) return;

        var variantId = sizeBtn.getAttribute('data-variant-id');
        selectedVariantInput.value = variantId;

        // Reveal ATC buttons — CSS breakpoint rules hide the wrong one per screen size
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('hidden');
        }
        if (addToCartBtnMobile) {
          addToCartBtnMobile.classList.remove('hidden');
        }

        chooseSizeBtn.textContent = 'Selected: ' + sizeBtn.textContent.trim();
        chooseSizeBtn.classList.add('size-selected');
        chooseSizeBtn.classList.remove('size-options--open');
        sizeOptions.classList.add('hidden');
        if (sizeSelector) sizeSelector.classList.remove('size-is-open');
        isOpen = false;

        sizeOptions.querySelectorAll('.size-option').forEach(function (b) {
          b.classList.remove('selected-size');
        });
        sizeBtn.classList.add('selected-size');

        // Update displayed price to the selected variant's price
        var price = parseInt(sizeBtn.getAttribute('data-price'), 10);
        var compareAt = parseInt(sizeBtn.getAttribute('data-compare-at') || '0', 10);
        if (!isNaN(price)) bcUpdatePrice(quickAdd, price, compareAt, variantId);
      });

      // Close picker on any outside click (attach once per document)
      if (!document._bcPickerDocHandler) {
        document._bcPickerDocHandler = true;
        document.addEventListener('click', function () {
          document.querySelectorAll('.card__quick-add').forEach(function (qa) {
            var opts = qa.querySelector('.size-options');
            var btn = qa.querySelector('.choose-size-btn');
            var sel = qa.querySelector('.size-selector');
            if (opts && !opts.classList.contains('hidden')) {
              opts.classList.add('hidden');
              if (btn) {
                btn.classList.remove('size-options--open');
              }
              if (sel) sel.classList.remove('size-is-open');
            }
          });
        });
      }
    });
  }

  initCards();
  window.addEventListener('bcj:promotion:change', bcRefreshPrices);
  // Collections are replaced via AJAX; cards also appear on home and recommendations.
  new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        return node.nodeType === 1 && (node.matches('.grid-product, .grid-product__content') || node.querySelector('.grid-product, .grid-product__content'));
      });
    })) initCards();
  }).observe(document.body, { childList: true, subtree: true });
})();
